import { render, staticRenderFns } from "./ElementLengths.vue?vue&type=template&id=1a52f81b&scoped=true&"
import script from "./ElementLengths.vue?vue&type=script&lang=js&"
export * from "./ElementLengths.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a52f81b",
  null
  
)

export default component.exports